import React, { useEffect, useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import ButtonIconSearch from '../../../../components/button/ButtonIconSearch'
import CardFooter from '../../../../components/card/CardFooter'
import CardPagination from '../../../../components/card/CardPagination'
import Tdbody from '../../../../components/table/Tdbody'
import Thead from '../../../../components/table/Thead'
import { GetClientsApi } from '../../../../http/Services/ClientApi'

export default function ModalClientList({
    show,
    handleClose,
    title,
    buttonText,
    variant,
    setClient,
    client
}) {
    const [clients, setClients] = useState([])
    // const [client, setClient] = useState({})
    const [orderBy, setOrderBy] = useState('id')
    const [orderByDesc, setOrderByDesc] = useState('ASC')
    const [typeQuery, setTypeQuery] = useState('nombre')
    const [forQuery, setForQuery] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [perPage, setPerPage] = useState(10)

    let num = 1

    const ordered = (type) => {
        setOrderBy(type)
        setOrderByDesc(orderByDesc === "DESC" ? "ASC" : "DESC")
    }
    useEffect(() => {
        const getClients = async () => {
            try {
                let res = await GetClientsApi(currentPage, perPage, forQuery, typeQuery, orderBy, orderByDesc);
                if (res.status === 200) {
                    setClients(res.data)
                }
            } catch (error) {

            }
        }
        getClients()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forQuery, orderBy, orderByDesc, perPage, currentPage])

    const selected = (data) => {
        setClient(data)
    }
    const unSelected = () => {
        setClient(null)
        handleClose()

    }
    return (
        <Modal show={show} onHide={handleClose} animation={true} >
            <Modal.Header closeButton>
                <Modal.Title className='h6 fw-bold text-secondary'>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: 'center' }}>
                <div className="card">
                    <div className='col-12 mb-2 pt-2'>
                        <ButtonIconSearch
                            variant="danger"
                            placeholder="buscar cliente..."
                            setTypeQuery={setTypeQuery}
                            setForQuery={setForQuery}
                            reset={true}
                        />
                    </div>
                    <CardPagination
                        current={clients.current_page}
                        last={clients.last_page}
                        setCurrentPage={setCurrentPage}
                        per_page={clients.per_page}
                        setPerPage={setPerPage}
                    />
                    <Table hover size="sm" className='mb-0' striped responsive style={{ border: '4px solid #495057' }}>
                        <Thead
                            columns={[
                                ["", "30px", () => ordered('id'), true],
                                ["Nombre", "180px", () => ordered('nombre'), true],
                                ["Telefono", "100px"],
                            ]}
                        />
                        <tbody>
                            {
                                clients.data &&
                                clients.data.map((data) => (
                                    <tr key={data.id} style={{ cursor: 'pointer', fontWeight: '600' }}
                                        onClick={() => selected(data)}
                                        className={client && client.id === data.id ? 'table-success fw-bold' : ''}
                                    >
                                        <Tdbody
                                            position='right'
                                            fsSmall='15px'
                                        >
                                            {clients.current_page === 1 ? num++ : (clients.current_page * 5 - 5 + num++)}

                                        </Tdbody>
                                        <Tdbody
                                            position='left'
                                            fsSmall='15px'
                                        >
                                            {data.nombre}{' '}
                                            {data.apellido_paterno}{' '}
                                            {data.apellido_materno}{' '}
                                        </Tdbody>
                                        <Tdbody
                                            position='left'
                                            fsSmall='15px'
                                        >{data.telefono}</Tdbody>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                    <div className="card-footer row p-0 d-flex justify-content-end">
                        {/* <div className="col-3">
                            <CardFooter
                                total={'Páginas: ' + (clients.last_page ? clients.last_page : 0)}
                            />
                        </div> */}
                        <div className="col-3">
                            <CardFooter
                                total={'Páginas: ' + (clients.last_page ? clients.last_page : 0)}
                            />
                        </div>
                        <div className="col-3">
                            <CardFooter
                                total={'Total: ' + (clients.total ? clients.total : 0)}
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {/* <Button variant="secondary" onClick={() => unSelected()} >
                    Cancelar
                </Button> */}
                {client &&
                    <Button variant="warning" onClick={() => unSelected()} >
                        Quitar
                    </Button>
                }
                <Button variant={variant} style={{ background: '#00bfa5', border: 'none' }} onClick={handleClose} disabled={client ? false : true}>
                    {buttonText}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
